var exports = {
  "R": "xe564cbfb--fe9462--preloader",
  "c": "xe564cbfb--fe9462--preloader_overlay",
};

module.exports = exports;
